import { render, staticRenderFns } from "./RulesNonogram.vue?vue&type=template&id=430bad02"
import script from "./RulesNonogram.vue?vue&type=script&lang=js"
export * from "./RulesNonogram.vue?vue&type=script&lang=js"
import style0 from "./RulesNonogram.vue?vue&type=style&index=0&id=430bad02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports